const WITHAWAIT = true;
const ISFROMPAYMENTMODAL = true;

export default {
    WITHAWAIT,
    ISFROMPAYMENTMODAL,
    methods: {
        async joinPaymentInvoice(
            invoiceId,
            withAwait = !WITHAWAIT,
            isFromPaymentModal = !ISFROMPAYMENTMODAL
        ) {
            await this._getSetting();
            await this.$nextTick();

            // await this.$socket.client.on("connect"); // not working
            // problem which seem the v-broadcast not ready even here send the socket message and the the payment modal response a socket message, the v-broadcast still not capture the message
            if (withAwait) {
                await this._sleep(3000);
            }
            // Emit socket to target the opened payment modal then the modal will emit socket if it select this invoice
            this.$socket.client.emit("v-broadcast", {
                action: "payment:invoice-join",
                invoiceId: invoiceId,
                isFromPaymentModal: isFromPaymentModal,
                businessId: this.$root.setting.business_id,
                userName: this.$root.currentActor.fullname,
                userId: this.$root.currentActor.id
            });
        }
    }
};
